import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <undefined><div>{`
  `}<p parentName="div">{`Dear Friend,`}</p>{`
  `}<div parentName="div" {...{
          "className": "gnt-logo image-float-right"
        }}><span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "400px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "148.33333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAECAwQF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAffjHA7xhDpwhlf/xAAcEAACAQUBAAAAAAAAAAAAAAAAAQIDEBESIDL/2gAIAQEAAQUCG7VSHsccmq5//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFREBAQAAAAAAAAAAAAAAAAAAESD/2gAIAQIBAT8BI//EABcQAAMBAAAAAAAAAAAAAAAAAAIgMDH/2gAIAQEABj8CQch//8QAHhABAAICAQUAAAAAAAAAAAAAAQARMUEQIFFhcYH/2gAIAQEAAT8hUMsHTBshusfYD2PPbglcA10//9oADAMBAAIAAwAAABADwvD/xAAWEQEBAQAAAAAAAAAAAAAAAAABEBH/2gAIAQMBAT8QXGaz/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/ENJMJ//EAB4QAQACAgEFAAAAAAAAAAAAAAEAESExQSBRYXHB/9oACAEBAAE/EFAAuYVbfncaxKjJFqTljfacxCNFvmBRLWu/bGREJky9P//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Good News Tour logo",
              "title": "Good News Tour logo",
              "src": "/static/ae59513f2f8411340a807aff9ff59242/066f9/gnt-logo-trees.jpg",
              "srcSet": ["/static/ae59513f2f8411340a807aff9ff59242/f93b5/gnt-logo-trees.jpg 300w", "/static/ae59513f2f8411340a807aff9ff59242/066f9/gnt-logo-trees.jpg 400w"],
              "sizes": "(max-width: 400px) 100vw, 400px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span></div>{`
  `}<p parentName="div">{` Earlier this year, I was in Palatka, Florida, an area that was pivotal in the early ministry of my grandfather Billy Graham. This was where he was baptized, ordained into ministry, and where he preached his first official sermon.`}</p>{`
  `}<p parentName="div">{` `}<strong parentName="p">{`This beautiful state is often referred to as one of America’s top destinations, but my heart broke for the eternal destination of millions of its residents. `}</strong>{` The spiritual need there is so great. I saw a recent survey that said a third of Floridians say they don’t believe in Heaven. And two-thirds rarely—if ever—read the Bible, whose very pages show the way to eternal life in Jesus Christ.`}</p>{`
  `}<div parentName="div" {...{
          "className": "will-church image-float-left"
        }}>{`
  `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "141.66666666666666%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAcABQDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAMEAgUG/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIQAxAAAAGvaVlaefC7sd0xrA8y/wD/xAAfEAACAgEEAwAAAAAAAAAAAAABAgADBBESEyIUIzH/2gAIAQEAAQUC8ksXtauLkgjHHpbJELdhVoi0rt4Vlp6j5P/EABYRAQEBAAAAAAAAAAAAAAAAAAAREP/aAAgBAwEBPwHIj//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/AYs//8QAHRAAAQQCAwAAAAAAAAAAAAAAAAEREiECMRAgof/aAAgBAQAGPwJsUNVxJrGi6CtojKjfnX//xAAcEAACAgMBAQAAAAAAAAAAAAAAAREhMUFRgbH/2gAIAQEAAT8h3t0Wsm3SSNR6RKiSyxN3bLMSyoYyiEQkV7k52H1+jFRmK2I//9oADAMBAAIAAwAAABBY9AD/xAAXEQADAQAAAAAAAAAAAAAAAAAAAREQ/9oACAEDAQE/EMVEH//EABcRAQEBAQAAAAAAAAAAAAAAAAEAIRH/2gAIAQIBAT8QLrIYW3//xAAeEAEBAAIDAAMBAAAAAAAAAAABEQAhMUFRcaGxwf/aAAgBAQABPxDuQ4G8IDyxVj/MiyuHXCtTepQfcSgrkh1Ovcs06wdHWOxO4wA2/uIZETQUmjfxldg9gPrJyHLlmwpWubHLn//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Will Graham stands in front of a church",
              "title": "Will Graham stands in front of a church",
              "src": "/static/e4bfb9ebd34abb13287f8d02089c324a/c08c5/will-graham-church.jpg",
              "srcSet": ["/static/e4bfb9ebd34abb13287f8d02089c324a/f93b5/will-graham-church.jpg 300w", "/static/e4bfb9ebd34abb13287f8d02089c324a/b4294/will-graham-church.jpg 600w", "/static/e4bfb9ebd34abb13287f8d02089c324a/c08c5/will-graham-church.jpg 640w"],
              "sizes": "(max-width: 640px) 100vw, 640px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>{`
  `}<figcaption parentName="div">{`Will Graham visited Peniel Baptist Church, where his grandfather Billy Graham was ordained in 1939.`}</figcaption>{`
  `}</div>{`
  `}<p parentName="div">{` With a burdened heart, I prayed and began to sense the Holy Spirit’s leading. It became clear to me that now is the time to return to proclaim the truth of the Gospel across Florida. `}<strong parentName="p">{`I’m excited to announce the Sunshine State Good News Tour, which will go to four cities this fall—Tallahassee, Gainesville, Sarasota, and Pompano Beach.`}</strong></p>{`
  `}<p parentName="div">{` At each stop, award-winning musical guests will lead us in worship, and I’ll share the Gospel—giving people the opportunity to follow Jesus Christ as Savior and receive the eternal salvation that He alone offers.`}</p>{`
  `}<p parentName="div">{` Will you join me in praying for these communities? Though the outreach is still several months away, we must begin preparing the spiritual ground now, before we proclaim that Jesus is `}<em parentName="p">{`“the way, the truth, and the life. No one comes to the Father except through `}</em>{`[`}<em parentName="p">{`Him`}</em>{`]`}<em parentName="p">{`”`}</em>{` (John 14:6, NKJV). We are partnering with churches in each city, and they have begun the work of getting the word out about the tour. `}<strong parentName="p">{`Your prayerful support is vital.`}</strong></p>
      </div>
      <br></br></undefined>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      